import { create } from 'zustand'

import type { NullableProperty, RefundRequestPayload } from '@/api/client/refund/dto/refundDto'
import Shared from '@/shared'
import type { RefundPayloadStates, RefundPayloadActions } from '@/shared/states/refund/types'

import { REFUND_REQUEST_TYPE } from '@/enums/myTicket/refund'

export const useRefundStore = create<RefundPayloadStates & RefundPayloadActions>((set) => ({
  refundStep: 1,
  refundListData: null,
  refundPayload: {
    requestType: null,
    refundableType: null,
    refundableSeq: 0,
    requestReason: null,
    requestTemplate: null,
    requestJson: null,
    guestCode: null
  },
  isOnSiteRefund: false, // NOTE: 현장결제 환불 여부 체크
  isParkinglotRefund: false, // NOTE: 주차권 환불 여부 체크
  isRefundSuccess: false,
  isRefundFailure: false,
  refundRequestErrorMsg: '',
  isParkinglotRefundProcess: false, // NOTE: 주차권 환불 프로세스 진입 여부 (현장결제 포함 && RefundParkinglot 컴포넌트 렌더링 목적)
  isSharedParkinglotRefundProcess: false, // NOTE: 공유주차권 환불 프로세스 진입 여부 (RefundSharedParkinglot 컴포넌트 렌더링 목적)
  isOnSitePaidRefundRetry: false, // NOTE: 현장결제 환불 재접수 신청
  requestSeq: 0, // NOTE: 재접수시 기존 환불요청 seq (comment 참고 목적)

  setRefundStep: (payload) => set({ refundStep: payload }),
  setRefundPayload: (value: NullableProperty<RefundRequestPayload>, key?: keyof RefundRequestPayload) => {
    if (key) {
      return set((state) => ({
        refundPayload: { ...state.refundPayload, [key]: value }
      }))
    } else {
      return set({ refundPayload: value })
    }
  },
  setRefundListData: (payload) => {
    if (payload) {
      const isOnSiteRefundIncludes = payload.results.some(
        (refund) => refund.requestType === REFUND_REQUEST_TYPE.ON_SITE_PAID
      )
      const isParkinglotRefundIncludes = payload.results.some(
        (refund) => refund.requestType === REFUND_REQUEST_TYPE.DAILY || refund.requestType === REFUND_REQUEST_TYPE.SHARE
      )
      set({ isOnSiteRefund: isOnSiteRefundIncludes })
      set({ isParkinglotRefund: isParkinglotRefundIncludes })
    }
    return set({ refundListData: payload })
  },
  setIsOnSiteRefund: (payload) => set({ isOnSiteRefund: payload }),
  setIsParkinglotRefund: (payload) => set({ isParkinglotRefund: payload }),
  setIsRefundSuccess: (payload) => set({ isRefundSuccess: payload }),
  setIsRefundFailure: (payload) => set({ isRefundFailure: payload }),
  setRefundRequestErrorMsg: (payload) => set({ refundRequestErrorMsg: payload }),
  setIsParkinglotRefundProcess: (payload) => set({ isParkinglotRefundProcess: payload }),
  setIsSharedParkinglotRefundProcess: (payload) => set({ isSharedParkinglotRefundProcess: payload }),
  setIsOnSitePaidRefundRetry: (payload) => set({ isOnSitePaidRefundRetry: payload }),
  setRequestSeq: (payload) => set({ requestSeq: payload })
}))

export const refundListDataNonNullableSelector = (store: RefundPayloadStates & RefundPayloadActions) => {
  const { refundListData } = store
  if (refundListData == null) {
    throw new Shared.Errors.ClientDataNullError('환불 내역 데이터가 존재하지 않습니다.')
  }

  return {
    refundListData
  }
}
